module.exports = __webpack_public_path__ + "static/media/flexi_szlahu_white.0f4c758f.svg";